import script from "./transfer.vue?vue&type=script&lang=ts&setup=true"
export * from "./transfer.vue?vue&type=script&lang=ts&setup=true"

import "./transfer.vue?vue&type=style&index=0&id=605777bb&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605777bb"]])

export default __exports__